import { jsx as l } from "react/jsx-runtime";
const o = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M2.293 2.293a1 1 0 0 1 1.414 0L15.635 14.22l2.428 2.42q.039.038.072.08l3.572 3.572a1 1 0 0 1-1.414 1.414l-3.087-3.087A10.3 10.3 0 0 1 12 20c-4.48 0-8.093-2.647-10.868-7.504a1 1 0 0 1 0-.992C2.31 9.444 3.637 7.777 5.127 6.54L2.293 3.707a1 1 0 0 1 0-1.414m12.535 11.121-4.242-4.242-.707.707a3 3 0 1 0 4.242 4.242zM12 5a9.5 9.5 0 0 0-2.637.365l10.134 10.123Q20.833 14.042 22 12q-4-7-10-7",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
